import React from 'react';
import styled, { keyframes } from 'styled-components';
import { prop } from 'styled-tools';

import HaloPlotPoints from 'components/HaloPlotPoints';

/*
 * Styles
 */

const PathIn = keyframes`
  0% {
    opacity: 0;
  }
`;

const Path = styled.path`
  animation: ${PathIn} 1800ms 1800ms ${prop('theme.settings.easings.quintOut')} 1 backwards};
  fill: none
  stroke: ${prop('theme.colors.orange')};
  stroke-width: 2px
`;

/*
 * Component
 */

const HaloPlot = (props) => {
  const { arcAngleCentroid, arcRadius, d, data, pointRadius } = props;

  return (
    <g>
      <Path d={d}></Path>
      <HaloPlotPoints
        arcAngleCentroid={arcAngleCentroid}
        arcRadius={arcRadius}
        data={data}
        pointRadius={pointRadius}
      />
    </g>
  )
};

export default HaloPlot;
